import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getProductFeature() {
  const data = await axiosInstance({
    url: "/product/feature",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createProductFeature(formData) {
  const data = await axiosInstance({
    url: "/product/feature",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateProductFeature(formData) {
  const data = await axiosInstance({
    url: `/product/feature/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteProductFeature(formData) {
  const data = await axiosInstance({
    url: `/product/feature/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useProductFeature() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.productFeature],
    queryFn: getProductFeature,
  });
  return data;
}

export function useUpdateProductFeature() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateProductFeature(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.productFeature]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddProductFeature() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createProductFeature(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.productFeature]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteProductFeature() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteProductFeature(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.productFeature]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
